import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sprout, Leaf, TreeDeciduous, Flower, Trees, Droplets } from 'lucide-react';
export function Modules() {
  const modules = [{
    emoji: '📕',
    icon: Sprout,
    bg: 'bg-emerald-50',
    border: 'border-emerald-300',
    hoverBorder: 'hover:border-emerald-600',
    accent: 'text-emerald-700',
    accentBg: 'bg-emerald-100',
    number: 1,
    title: 'Mentalidad & Preparación',
    subtitle: 'Arrancá sin errores',
    items: ['Qué necesitás (y qué no)', 'Empezá sin gastar de más', 'Adaptá cualquier espacio']
  }, {
    emoji: '📗',
    icon: Leaf,
    bg: 'bg-lime-50',
    border: 'border-lime-300',
    hoverBorder: 'hover:border-lime-600',
    accent: 'text-lime-700',
    accentBg: 'bg-lime-100',
    number: 2,
    title: 'Qué plantar',
    subtitle: 'Plantas ideales para empezar',
    items: ['Cultivos fáciles', 'Lo que crece rápido', 'Qué NO plantar']
  }, {
    emoji: '📘',
    icon: TreeDeciduous,
    bg: 'bg-green-50',
    border: 'border-green-300',
    hoverBorder: 'hover:border-green-600',
    accent: 'text-green-700',
    accentBg: 'bg-green-100',
    number: 3,
    title: 'Armado de tu huerta',
    subtitle: 'Tu primer setup',
    items: ['Armá tu espacio', 'Macetas y opciones low cost', 'Organización simple']
  }, {
    emoji: '📙',
    icon: Droplets,
    bg: 'bg-teal-50',
    border: 'border-teal-300',
    hoverBorder: 'hover:border-teal-600',
    accent: 'text-teal-700',
    accentBg: 'bg-teal-100',
    number: 4,
    title: 'Riego correcto',
    subtitle: 'No mates tus plantas',
    items: ['Cuándo regar', 'Cuánta agua usar', 'Errores a evitar']
  }, {
    emoji: '📔',
    icon: Trees,
    bg: 'bg-green-100/60',
    border: 'border-green-400',
    hoverBorder: 'hover:border-green-700',
    accent: 'text-green-800',
    accentBg: 'bg-green-200',
    number: 5,
    title: 'Mantenimiento simple',
    subtitle: 'Sostené tu huerta sin esfuerzo',
    items: ['Rutina de 5 minutos', 'Control semanal', 'Hacela sostenible']
  }, {
    emoji: '📒',
    icon: Flower,
    bg: 'bg-emerald-100/60',
    border: 'border-emerald-400',
    hoverBorder: 'hover:border-emerald-700',
    accent: 'text-emerald-800',
    accentBg: 'bg-emerald-200',
    number: 6,
    title: 'Escalar y ahorrar',
    subtitle: 'Tu huerta = ahorro real',
    items: ['Producí más', 'Plantá estratégicamente', 'Reducí gastos en el súper']
  }];
  return <section className="relative w-full py-8 md:py-16 px-4 bg-white overflow-hidden" data-id="element-152">
      {/* Section-wide decorative leaves */}
      <motion.div animate={{
      y: [0, -10, 0],
      rotate: [0, 5, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-10 left-4 opacity-[0.06] pointer-events-none hidden md:block" aria-hidden="true" data-id="element-153">
        <Leaf className="w-32 h-32 text-green-800" data-id="element-154" />
      </motion.div>
      <motion.div animate={{
      y: [0, 10, 0],
      rotate: [0, -5, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-10 right-4 opacity-[0.06] pointer-events-none hidden md:block" aria-hidden="true" data-id="element-155">
        <Sprout className="w-40 h-40 text-green-800" data-id="element-156" />
      </motion.div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-157">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-158">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`relative overflow-hidden ${module.bg} border-2 ${module.border} ${module.hoverBorder} rounded-2xl p-5 md:p-6 transition-all duration-300 group`} data-id="element-159">
              {/* Large Faded Number */}
              <div className="absolute -right-2 -bottom-6 text-8xl md:text-9xl font-black text-green-900 opacity-[0.04] pointer-events-none select-none" aria-hidden="true" data-id="element-160">
                0{module.number}
              </div>

              {/* Top-right decorative icon (main) */}
              <motion.div className="absolute top-3 right-3 opacity-[0.12] pointer-events-none" animate={{
            rotate: [0, 8, 0, -8, 0]
          }} transition={{
            duration: 5 + index,
            repeat: Infinity,
            ease: 'easeInOut'
          }} aria-hidden="true" data-id="element-161">
                <module.icon className={`w-20 h-20 md:w-24 md:h-24 ${module.accent}`} data-id="element-162" />
              </motion.div>

              {/* Top-left small leaf accent */}
              <motion.div className="absolute top-2 left-2 opacity-20 pointer-events-none" animate={{
            rotate: [0, 15, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: index * 0.3
          }} aria-hidden="true" data-id="element-163">
                <Leaf className={`w-5 h-5 ${module.accent}`} data-id="element-164" />
              </motion.div>

              {/* Bottom-left tiny sprout */}
              <motion.div className="absolute bottom-3 left-3 opacity-20 pointer-events-none" animate={{
            y: [0, -3, 0]
          }} transition={{
            duration: 3 + index * 0.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} aria-hidden="true" data-id="element-165">
                <Sprout className={`w-4 h-4 ${module.accent}`} data-id="element-166" />
              </motion.div>

              {/* Mid-right tiny leaf */}
              <motion.div className="absolute top-1/2 right-6 opacity-15 pointer-events-none" animate={{
            rotate: [0, -20, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: index * 0.4
          }} aria-hidden="true" data-id="element-167">
                <Leaf className={`w-3 h-3 ${module.accent}`} data-id="element-168" />
              </motion.div>

              <div className="relative z-10" data-id="element-169">
                <div className="flex items-center gap-3 mb-3" data-id="element-170">
                  <span className="text-3xl md:text-4xl" data-id="element-171">{module.emoji}</span>
                  <div className={`text-xs md:text-sm font-bold uppercase tracking-wider ${module.accent} ${module.accentBg} px-3 py-1 rounded-full flex items-center gap-1`} data-id="element-172">
                    <Sprout className="w-3 h-3" data-id="element-173" />
                    Módulo {module.number}
                  </div>
                </div>

                <h3 className="text-xl md:text-2xl font-bold text-green-950 mb-2 leading-tight" data-id="element-174">
                  {module.title}
                </h3>
                <p className="text-sm text-green-900/70 mb-5 italic font-medium" data-id="element-175">
                  {module.subtitle}
                </p>

                <div className="space-y-3 bg-white/60 p-4 rounded-xl backdrop-blur-sm border border-white/40" data-id="element-176">
                  <p className={`text-xs font-bold uppercase tracking-wide ${module.accent} flex items-center gap-1`} data-id="element-177">
                    <Leaf className="w-3 h-3" data-id="element-178" />
                    Incluye:
                  </p>
                  {module.items.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-179">
                      <Check className={`w-4 h-4 ${module.accent} flex-shrink-0 mt-0.5`} data-id="element-180" />
                      <span className="text-sm text-gray-800 font-medium" data-id="element-181">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}